document.addEventListener('DOMContentLoaded', () => {

    document.addEventListener('click', async (event) => {

        const link = event.target.closest('.lw-pagination__link');

        if (!link) return;

        event.preventDefault();

        const gridContent = document.querySelector(
            '#lw-collection-grid-content'
        );

        if (!gridContent) return;

        gridContent.classList.add('is-loading');

        try {

            const url = new URL(link.href);

            url.searchParams.set(
                'section_id',
                'lw-main-blog'
            );

            const response = await fetch(url);

            const html = await response.text();

            const parser = new DOMParser();

            const doc = parser.parseFromString(
                html,
                'text/html'
            );

            const newGrid = doc.querySelector(
                '#lw-collection-grid-content'
            );

            const newPagination = doc.querySelector(
                '.lw-pagination'
            );

            if (newGrid) {
                gridContent.replaceWith(newGrid);
            }

            const oldPagination =
                document.querySelector('.lw-pagination');

            if (oldPagination && newPagination) {
                oldPagination.replaceWith(newPagination);
            }

            window.history.pushState(
                {},
                '',
                link.href
            );

            document
                .querySelector('#lw-collection-grid')
                ?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });

        } catch (error) {

            console.error(
                'Pagination failed:',
                error
            );

        }

    });

});